<template>
    <div>
        <h1 class="page-title" v-if="curator.id">{{ curator.displayName }}</h1>
    </div>
</template>

<script>
  import axios from 'axios';

  export default {
    props: {
      id: {
        required: true,
        type: [String, Number],
      },
    },
    data() {
      return {
        apiUrl: '/users/curators/',
        curator: {},
      };
    },

    created() {
      this.getCurator(this.id);
    },
    methods: {
      getCurator: async function(curatorId) {
        try {
          let response = await axios.get(this.apiUrl + curatorId);
          this.curator = response.data.data;
        } catch (error) {
          console.dir(error);
        }
      },
    },

  };
</script>


// WEBPACK FOOTER //
// src/modules/user/curator/profile/components/CuratorInfo.vue